import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class OdemeEmirleriListeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "OdemeEmirleriListe";
        super(baseUrl);
    }


    getOdemeEmirleriListe( sicilKodu: number,durum: number) {
        var request = new OdemeEmirleriListeRequest(sicilKodu,durum);
        return this.post("", request, false);
    }

}
export default new OdemeEmirleriListeAPI();
class OdemeEmirleriListeRequest {
    public sicilKodu: number;
    public durum: number;
    constructor( sicilKodu: number, durum: number) {

        this.sicilKodu = sicilKodu;
        this.durum = durum;

    }
}
export { OdemeEmirleriListeRequest };
